import { RootService } from './rootService';

export const services = new RootService();
